<template>
    <div class="content-wrapper">
        <div class="row">
            <app-breadcrumb :page-title="$t('odds')" :directory="$t('datatables')" :icon="'grid'" class="col-6"/>
        </div>
        <div class="pb-4">
            <div class="col-12 ">
                <div class="filters-wrapper">
                    <template v-for="(market, index) in customFilters">
                        <div class="row">
                            <template v-for="(item, index) in market">
                                <div class="single-filter">
                                    <div class="dropdown">
                                        <button
                                            id="odds-odds-table"
                                            class="btn btn-filter"
                                            :class="item.active ? 'applied' : ''"
                                            @click.prevent="applyFilter(item)">
                                            {{ item.name }}
                                        </button>
                                    </div>
                                </div>
                            </template>
                        </div>
                    </template>
                </div>
            </div>
        </div>
        <div class="pb-4">
            <div class="col-12 shadow">
                <div class="filters-wrapper row" style="background: var(--default-card-bg);">
                    <template v-for="(market, key, index) in customFilters">
                        <div class="col-4">
                            <div class="row py-2" style="background: var(--default-card-hightlight-bg);" v-if="key === 'ft'">
                                <div class="col-12">
                                    {{ $t('wdw') }}
                                </div>
                            </div>
                            <div class="row py-2" style="background: var(--default-card-hightlight-bg);" v-if="key === 'ah'">
                                <div class="col-4">
                                    {{ $t('asian_handicap') }}
                                </div>
                                <div class="col-4">
                                    {{ $t('home') }}
                                </div>
                                <div class="col-4">
                                    {{ $t('away') }}
                                </div>
                            </div>
                            <div class="row py-2" style="background: var(--default-card-hightlight-bg);" v-if="key === 'ou'">
                                <div class="col-4">
                                    {{ $t('over_under') }}
                                </div>
                                <div class="col-4">
                                    {{ $t('over') }}
                                </div>
                                <div class="col-4">
                                    {{ $t('under') }}
                                </div>
                            </div>
                            <template v-for="(item, index) in market">
                                <div class="flex-column">
                                    <div class="dropdown">
                                        <template v-if="key === 'ft'">
                                            <div class="row py-1" style="border-top: 1px solid var(--default-border-color);">
                                                <div class="col-6">
                                                    {{ $t(item.name.toLowerCase()) }}
                                                </div>
                                                <div class="col-6">
                                                    <template v-if="typeof item.data.highest !== 'undefined' && item.data.highest === true">
                                                        <span style="color: #81bf5c;">{{ formatPrice(item.data.value) }}</span> ( {{ item.data.percentage }}% )
                                                    </template>
                                                    <template v-else>
                                                        {{ formatPrice(item.data.value) }}
                                                    </template>
                                                </div>
                                            </div>
                                        </template>
                                        <template v-if="key === 'ah'">
                                            <div class="row py-1" style="border-top: 1px solid var(--default-border-color);">
                                                <div class="col-4">
                                                    {{ item.dataKey }}
                                                </div>
                                                <div class="col-4">
                                                    <template v-if="typeof item.data.home.highest !== 'undefined' && item.data.home.highest === true">
                                                        <span style="color: #81bf5c;">{{ formatPrice(item.data.home.value) }}</span> ( {{ item.data.home.percentage }}% )
                                                    </template>
                                                    <template v-else>
                                                        {{ formatPrice(item.data.home.value) }}
                                                    </template>
                                                </div>
                                                <div class="col-4">
                                                    <template v-if="typeof item.data.away.highest !== 'undefined' && item.data.away.highest === true">
                                                        <span style="color: #81bf5c;">{{ formatPrice(item.data.away.value) }}</span> ( {{ item.data.away.percentage }}% )
                                                    </template>
                                                    <template v-else>
                                                        {{ formatPrice(item.data.away.value) }}
                                                    </template>
                                                </div>
                                            </div>
                                        </template>
                                        <template v-if="key === 'ou'">
                                            <div class="row py-1" style="border-top: 1px solid var(--default-border-color);">
                                                <div class="col-4">
                                                    {{ item.dataKey }}
                                                </div>
                                                <div class="col-4">
                                                    <template v-if="typeof item.data.over.highest !== 'undefined' && item.data.over.highest === true">
                                                        <span style="color: #81bf5c;">{{ formatPrice(item.data.over.value) }}</span> ( {{ item.data.over.percentage }}% )
                                                    </template>
                                                    <template v-else>
                                                        {{ formatPrice(item.data.over.value) }}
                                                    </template>
                                                </div>
                                                <div class="col-4">
                                                    <template v-if="typeof item.data.under.highest !== 'undefined' && item.data.under.highest === true">
                                                        <span style="color: #81bf5c;">{{ formatPrice(item.data.under.value) }}</span> ( {{ item.data.under.percentage }}% )
                                                    </template>
                                                    <template v-else>
                                                        {{ formatPrice(item.data.under.value) }}
                                                    </template>
                                                </div>
                                            </div>
                                        </template>
                                    </div>
                                </div>
                            </template>
                            <div class="row py-2" style="background: var(--default-card-hightlight-bg);" v-if="key === 'ft'">
                                <div class="col-6">
                                    {{ $t('total') }}
                                </div>
                                <div class="col-6">
                                    {{ formatPrice(customTotals.ft.all) }}
                                </div>
                            </div>
                            <div class="row py-2" style="background: var(--default-card-hightlight-bg);" v-if="key === 'ah'">
                                <div class="col-4">
                                    {{ $t('total') }}
                                </div>
                                <div class="col-4">
                                    {{ formatPrice(customTotals.ah.home) }}
                                </div>
                                <div class="col-4">
                                    {{ formatPrice(customTotals.ah.away) }}
                                </div>
                            </div>
                            <div class="row py-2" style="background: var(--default-card-hightlight-bg);" v-if="key === 'ou'">
                                <div class="col-4">
                                    {{ $t('total') }}
                                </div>
                                <div class="col-4">
                                    {{ formatPrice(customTotals.ou.over) }}
                                </div>
                                <div class="col-4">
                                    {{ formatPrice(customTotals.ou.under) }}
                                </div>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
        </div>
        <div class="mb-primary">
            <h5 class="mb-3 d-none">{{ $t('filters') }}</h5>
            <app-table :id="'betfair-sports-filter-table'" :options="options" @action="getAction"/>
        </div>
    </div>
</template>

<script>

import * as actions from "../../../../Config/ApiUrl";
import CoreLibrary from "../../../../../core/helpers/CoreLibrary";
import { FormMixin } from "../../../../../core/mixins/form/FormMixin.js";
import {BETFAIR_GAME_DATA} from "../../../../Config/ApiUrl";

export default {
    name: "betfair-log-filter",
    mixins: [FormMixin],
    extends: CoreLibrary,
    props: ['sport', 'game_id', 'custom_filters'],
    data() {
        return {
            customFilters: {
                'ft': [],
                'ah': [],
                'ou': []
            },
            customTotals: {
                'ft': {
                    'all': 0,
                },
                'ah': {
                    'home': 0,
                    'away': 0,
                },
                'ou': {
                    'over': 0,
                    'under': 0,
                }
            },
            selectableCustomFilters: [],
            confirmedModal: false,
            alertModal: false,
            createAlertModal: false,
            selectedRow: null,
            selectedConditions: {
                'wdw': {},
                'ah': {},
                'ou': {}
            },
            options: {
                id: 'betfair-sports-table',
                name: this.$t('sports_filter'),
                url: actions.BETFAIR_GAME_DATA + '/' + this.game_id,
                showHeader: true,
                showCount: true,
                showClearFilter: true,
                enableSaveFilter: true,
                columns: [
                    {
                        title: 'ID',
                        type: 'text',
                        key: 'id',
                    },
                    {
                        title: this.$t('sport'),
                        type: 'custom-html',
                        key: 'game',
                        modifier: (value) => {
                            if (value != null){
                                return this.$t(value.sport.toLowerCase());
                            }
                            return '-';
                        }
                    },
                    {
                        title: this.$t('name'),
                        type: 'custom-html',
                        key: 'game',
                        modifier: (value) => {
                            if (value != null){
                                return '<a href="' + window.location.href + '&gameid=' + value.id + '">' + value.name + '</a>';
                            }
                            return '-';
                        }
                    },
                    {
                        title: this.$t('competition'),
                        type: 'custom-html',
                        key: 'game',
                        modifier: (value) => {
                            if (value != null){
                                return '<a class="hidden-link" href="' + window.location.href + '&leagueid=' + value.external_competition_id + '">' + value.competition + '</a>';
                            }
                            return '-';
                        }
                    },
                    {
                        title: this.$t('market'),
                        type: 'custom-html',
                        key: 'market_type',
                        modifier: (value) => {
                            if (value != null){
                                return this.$t(value);
                            }
                            return '-';
                        }
                    },
                    {
                        title: this.$t('selection'),
                        type: 'custom-html',
                        key: 'market_name',
                        modifier: (value) => {
                            if (value != null){
                                // find the last space and split the string
                                let split = value.lastIndexOf(' ');
                                if (split === -1){
                                    return this.$t(value.toLowerCase());
                                }
                                let market = value.substring(0, split);
                                let number = value.substring(split + 1);
                                return this.$t(market.toLowerCase()) + ' ' + number;
                            }
                            return '-';
                        }
                    },
                    {
                        title: this.$t('last_price_traded') + '*',
                        type: 'trades-preview',
                        key: 'trades'
                    },
                    {
                        title: this.$t('added'),
                        type: 'trades-preview-price',
                        key: 'difference'
                    },
                    {
                        title: this.$t('total'),
                        type: 'custom-html',
                        key: 'new',
                        modifier: (value) => {
                            if (value != null){
                                return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'EUR' }).format(value);
                            }
                            return '-';
                        }
                    },
                    {
                        title: this.$t('market_total'),
                        type: 'custom-html',
                        key: 'market_total_matched',
                        modifier: (value) => {
                            if (value != null){
                                return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'EUR' }).format(value);
                            }
                            return '-';
                        }
                    },
                    {
                        title: this.$t('time'),
                        type: 'text',
                        key: 'created_at',

                    },
                ],
                actions: [
                ],
                filters: [
                    {
                        "title": this.$t('added_amount'),
                        "type": "editable-range-filter",
                        "key": "amount",
                        "maxTitle": "Max EUR",
                        "minTitle": "Min EUR",
                        "sign": "€",
                        "maxRange": 500000,
                        "minRange": 0
                    },
                    {
                        "title": this.$t('total_amount'),
                        "type": "editable-range-filter",
                        "key": "total",
                        "maxTitle": "Max EUR",
                        "minTitle": "Min EUR",
                        "sign": "€",
                        "maxRange": 5000000,
                        "minRange": 0
                    },
                    {
                        "title": 'Custom Filters',
                        "type": "checkbox",
                        "key": "custom_filters",
                        "option": this.selectableCustomFilters,
                        "listValueField": "name"
                    }

                ],
                showSearch: false,
                paginationType: "pagination",
                responsive: true,
                rowLimit: 50,
                showAction: true,
                actionType: "default",
                autoRefresh: true,
                autoRefreshSpeed: 2000,
                paginationOptions: [10, 25, 50, 100, 200],
            },
        }
    },
    created() {
        //this.options.url = actions.BETFAIR_DATATABLE_GAME_DATA + '/' + this.game_id;
        this.loadFilters();
        // loadfilters run every 3 seconds but do not run unless previous call is finished
        setInterval(() => {
            this.loadFilters();
        }, 3000);


    },
    methods: {
        getAction(row, actionObj, active) {
        },
        closeModal() {
            this.createAlertModal = false;
            this.confirmedModal = false;
            this.alertModal = false;
        },
        loadFilters() {
            let uri = window.location.href.split('?');
            let urlParams = {};
            if(uri.length === 2) {
                let vars = uri[1].split('&');
                let getVars = {};
                let tmp = '';
                vars.forEach(function (v) {
                    tmp = v.split('=');
                    if (tmp.length === 2)
                        getVars[tmp[0]] = tmp[1];
                });
                urlParams = getVars;
            }

            let customFilters = urlParams.custom_filters ? urlParams.custom_filters.split(',') : [];
            // update url
            let url = '?only_filters=1&';
            if(customFilters.length > 0) {
                url += 'custom_filters=' + customFilters.join(',');
            }
            if(urlParams.per_page) {
                url += '&per_page=' + urlParams.per_page;
            }
            if(urlParams.page) {
                url += '&page=' + urlParams.page;
            }

            console.log(url);
            let requestUrl = actions.BETFAIR_GAME_DATA + '/' + this.game_id + '/' + url;
            console.log(requestUrl)

            this.axiosGet(requestUrl).then(response => {
                let filters = response.data.filters;
                console.log(filters);
                if (filters.market_type.ft && filters.market_type.ft.lines) {
                    let market_type_ft = filters.market_type.ft.lines;
                    let market_type_ft_options = [];
                    for (const [key, item] of Object.entries(market_type_ft)) {
                        if (typeof item === 'object') {
                            let title = key;
                            let id = key;
                            market_type_ft_options.push(
                                {id: id, name: title}
                            );
                        }
                    }
                    /*this.options.filters.push({
                    "title": 'Full Time',
                    "type": "drop-down-filter",
                    "key": "ft",
                    "option": market_type_ft_options,
                    "listValueField": "name"
                });*/
                }
                if (filters.market_type.ah && filters.market_type.ah.lines) {
                    let market_type_ah = filters.market_type.ah.lines;
                    let market_type_ah_options = [];
                    for (const [key, item] of Object.entries(market_type_ah)) {
                        if (typeof item === 'object') {
                            let title = key;
                            let id = key;
                            market_type_ah_options.push(
                                {id: id, name: title}
                            );
                        }
                    }
                    /*this.options.filters.push({
                    "title": 'Asian Handicap',
                    "type": "drop-down-filter",
                    "key": "ah",
                    "option": market_type_ah_options,
                    "listValueField": "name"
                });*/
                }
                if (filters.market_type.ou && filters.market_type.ou.lines) {
                    let market_type_ou = filters.market_type.ou.lines;
                    let market_type_ou_options = [];
                    for (const [key, item] of Object.entries(market_type_ou)) {
                        if (typeof item === 'object') {
                            let title = key;
                            let id = key;
                            market_type_ou_options.push(
                                {id: id, name: title}
                            );
                        }
                    }
                    /*this.options.filters.push({
                    "title": 'Over / Under',
                    "type": "drop-down-filter",
                    "key": "ou",
                    "option": market_type_ou_options,
                    "listValueField": "name"
                });*/
                }

                //console.log(this.custom_filters);
                if (filters.market_type != null) {
                    let market_type = filters.market_type;
                    if (market_type.ft != null && market_type.ft.total != null) {
                        this.customTotals.ft.all = market_type.ft.total;
                    }
                    if (market_type.ft != null && market_type.ft.lines != null) {
                        for (const [key, item] of Object.entries(market_type.ft.lines)) {
                            // if key is not in selectableCustomFilters filters, add it otherwise update it
                            let index = this.selectableCustomFilters.findIndex(x => x.id === 'ft_' + key);
                            if (index === -1) {
                                this.selectableCustomFilters.push(
                                    { id: 'ft_' + key, name: this.$t(key.toLowerCase()) }
                                );
                            } else {
                                this.selectableCustomFilters[index].name = this.$t(key.toLowerCase());
                            }

                            console.log('ft_' + key + ' active: ' + item.active + ' ' + JSON.stringify(item));
                            // add to customFilters or update it
                            index = this.customFilters.ft.findIndex(x => x.id === 'ft_' + key);
                            if (index === -1) {
                                this.customFilters.ft.push({ id: 'ft_' + key, name: this.$t(key.toLowerCase()), data: item, dataKey: key, active: item.active });
                            } else {
                                this.customFilters.ft[index].data = item;
                                this.customFilters.ft[index].dataKey = key;
                                this.customFilters.ft[index].active = item.active;
                            }
                        }
                    }

                    if (market_type.ah != null && market_type.ah.total != null) {
                        if (market_type.ah.total.home != null){
                            this.customTotals.ah.home = market_type.ah.total.home;
                        }
                        if (market_type.ah.total.away != null){
                            this.customTotals.ah.away = market_type.ah.total.away;
                        }
                    }
                    if (market_type.ah != null && market_type.ah.lines != null) {
                        for (const [key, item] of Object.entries(market_type.ah.lines)) {
                            // if key is not in selectableCustomFilters filters, add it otherwise update it
                            let index = this.selectableCustomFilters.findIndex(x => x.id === 'ah_' + key);
                            if (index === -1) {
                                this.selectableCustomFilters.push(
                                    { id: 'ah_' + key, name: this.$t('asian_handicap') + ' ' + item.home.line }
                                );
                            } else {
                                this.selectableCustomFilters[index].name = this.$t('asian_handicap') + ' ' + item.home.line;
                            }
                            console.log('ah_' + key + ' active: ' + item.active + ' ' + JSON.stringify(item));
                            // add to customFilters or update it
                            index = this.customFilters.ah.findIndex(x => x.id === 'ah_' + key);
                            if (index === -1) {
                                this.customFilters.ah.push({ id: 'ah_' + key, name: this.$t('asian_handicap') + ' ' + item.home.line, data: item, dataKey: key, active: item.active });
                            } else {
                                this.customFilters.ah[index].data = item;
                                this.customFilters.ah[index].dataKey = key;
                                this.customFilters.ah[index].active = item.active;
                            }
                        }
                    }

                    if (market_type.ou != null && market_type.ou.total != null) {
                        if (market_type.ou.total.over != null){
                            this.customTotals.ou.over = market_type.ou.total.over;
                        }
                        if (market_type.ou.total.under != null){
                            this.customTotals.ou.under = market_type.ou.total.under;
                        }
                    }
                    if (market_type.ou != null && market_type.ou.lines != null) {
                        for (const [key, item] of Object.entries(market_type.ou.lines)) {
                            // if key is not in selectableCustomFilters filters, add it otherwise update it
                            let index = this.selectableCustomFilters.findIndex(x => x.id === 'ou_' + key);
                            if (index === -1) {
                                this.selectableCustomFilters.push(
                                    { id: 'ou_' + key, name: this.$t('over_under') + ' ' + key }
                                );
                            } else {
                                this.selectableCustomFilters[index].name = this.$t('over_under') + ' ' + key;
                            }
                            console.log('ou_' + key + ' active: ' + item.active + ' ' + JSON.stringify(item));
                            // add to customFilters or update it
                            index = this.customFilters.ou.findIndex(x => x.id === 'ou_' + key);
                            if (index === -1) {
                                this.customFilters.ou.push({ id: 'ou_' + key, name: this.$t('over_under') + ' ' + key, data: item, dataKey: key, active: item.active });
                            } else {
                                this.customFilters.ou[index].data = item;
                                this.customFilters.ou[index].dataKey = key;
                                this.customFilters.ou[index].active = item.active;
                            }
                        }
                    }
                }
            });
        },
        applyFilter(item) {

            // https://oddsalert.eu/game/272447?custom_filters=asian.set.-1.5,asian.set.1.5&per_page=50&page=1
            // check if the filter is already applied from the url using custom_filters

            // get url params
            let uri = window.location.href.split('?');
            let urlParams = {};
            if(uri.length === 2) {
                let vars = uri[1].split('&');
                let getVars = {};
                let tmp = '';
                vars.forEach(function (v) {
                    tmp = v.split('=');
                    if (tmp.length === 2)
                        getVars[tmp[0]] = tmp[1];
                });
                urlParams = getVars;
            }

            // check if the filter is already applied
            let customFilters = urlParams.custom_filters ? urlParams.custom_filters.split(',') : [];
            let filterIndex = customFilters.indexOf(item.id);
            if(filterIndex !== -1) {
                customFilters.splice(filterIndex, 1);
                item.active = false;
            } else {
                customFilters.push(item.id);
                item.active = true;
            }

            // update url
            let url = uri[0] + '?';
            if(customFilters.length > 0) {
                url += 'custom_filters=' + customFilters.join(',');
            }
            if(urlParams.per_page) {
                url += '&per_page=' + urlParams.per_page;
            }
            if(urlParams.page) {
                url += '&page=' + urlParams.page;
            }

            // redirect to the url
            window.location.href = url;
        },
        formatPrice(value) {
            return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
        }
    }
}
</script>